import { MenuItem } from "@mui/material";
import { Pencil } from "lucide-react";
import { useState } from "react";
import EditResaleListing from "../forms/edit";
import { ResaleListingFormFields } from "@/modules/property-tracks/utils";
import { useReadonlyContext } from "@/modules/common/context/read-only.context";

export default function EditResaleListingMenuItem({
  values,
  listingUid,
  trackUid,
}: {
  values: ResaleListingFormFields;
  listingUid: string;
  trackUid: string;
}) {
  const [open, setOpen] = useState(false);

  const { readonly } = useReadonlyContext();

  return (
    <>
      <MenuItem
      disabled={readonly}
        sx={(theme) => ({
          display: "flex",
          gap: theme.nawy.spacing.xs,
        })}
        onClick={() => setOpen(true)}
      >
        <Pencil />
        Edit Listing
      </MenuItem>

      <EditResaleListing
        open={open}
        setOpen={setOpen}
        listingUid={listingUid}
        trackUid={trackUid}
        values={values}
      />
    </>
  );
}
